// @flow

import { ReducerRegistry } from "../../../base/redux";
import { displayConsole } from "../../../webjam/helper";
import { FEATURE_CUSTOM_REDUX } from "../../constant"
import { getBaseConfig, PANNING_VAR } from "../../Utils";

import {
    SET_ACTIVE_MODAL_ID,
    SET_MENU_STATUS,
    UNSET_CONFERENCE,
    SET_CONFERENCE_JOINED,
    SET_INTERNET_STATUS,
    SET_USERS_DATA,
    SET_USER_CONNECTION_STATUS,
    HANDLE_WEBJAM_HOME_CLICK,
    SET_IPADDRESS_VIDEO,
    SET_SHOW_HIDE_STATUS_WEBJAM_MENU,
    SET_SOCKET_CONNECTION_STATUS,
    SET_DATA,
    SET_NAME,
    SET_JOIN_ROOM_MODAL_STATUS,
    SET_VIDEO_SCREEN_STATUS,
    SET_PROTOCOL,
    SET_HOST_DATA,
    SET_END_ROOM_DATA,
    SHOW_OR_HIDE_ERROR_MODAL,
    SHOW_HIDE_MODERATOR_DISCONNECT,
    SHOW_HIDE_MULTIMODERATOR_DISCONNECT,
    SHOW_TOAST_POPUP,
    CLOSE_VIDEO,
    SET_FCM_TOKEN,
    SET_DEVICE_LIST_DATA,
    API_GET_IPLIST,
    SHOW_API_LOADER,
    HIDE_API_LOADER,
    SET_PUBLIC_IP,
    SET_METRONOME_STATUS,
    SET_BUFFER_STATUS,
    SET_LATENCY_STATUS,
    SET_RECORDING,
    STOP_RECORDING,
    GHOST_LIST,
    SET_ROOM_OR_IP,
    HOST_TAB_DATA,
    CLICK_MAKE_HOST,
    HOST_TAB_RELOAD,
    SHOW_BUFFER_LOADER,
    AUDIO_GHOST,
    GHOST_VOICESYNC,
    CONNECT_AUDIO_GHOST,
    SET_HYBRID_SESSION,
    SET_LOGIN_MODAL,
    SET_USER_IS_LOGIN,
    SET_USER_LOGIN_DATA,
    SET_ROOM_PASS_PROTECT,
    SET_GHOST_RECORDING,
    AUTO_MAKE_HOST,
    CLICK_AUTO_MAKE_HOST,
    SET_WAITING_SCREEN,
    SET_CLOSE_AVATAR_POP,
    SET_HOST_REFRESH,
    SET_HOST_REFRESH_TIMER,
    SET_IS_CLAIM_CLICKED,
    SET_AUDIO_GHOST_CONNECT,
    SET_CHAT_RECORDING_FILES,
    SET_CHAT_RECORDING_FILES_VISIBILITY,
    SET_LOBBY_STATUS,
    SET_APP_URLS,
    SET_STEM_RECORDING,
    SET_STEM_RECORDING_URL,
    SET_DELAY_PANNING,
    SET_DEVICES_USERS,
    SET_PREV_PANNING,
    SET_HOST_WAIT_INIT,
    SET_DECODED_DATA,
    SET_AUTH_VERIFY_TOKEN,
    // SET_ORGANIZATION_LIST,
    // SET_ORGANIZATION,
    SET_TEACHER_WILL_WAIT,
    SET_STUDENT_MODERATOR,
    SET_ROOM_USERS,
    SET_STUDENT_SECOND_MODERATOR,
    SET_THIRD_PARTY_HOST_TAB_DATA,
    HOST_TAB_DATA_MAIN,
    SET_PREJOIN_INFO_CODE,
    SET_IS_LOGOUT,
    SET_WAITING_SCREEN_STATUS
    // SET_RECORDING_TYPE
} from './actionType';

ReducerRegistry.register(FEATURE_CUSTOM_REDUX, (state = {
    uniqueId: '',
    room: '',
    connected: '',
    showModal: false,
    showModalError: false,
    showModeratorModal: false,
    showMultiModeratorModal: false,
    toastModal: false,
    errorMessage: '',
    profileName: '',
    deviceList: [],
    menuStatus: true,
    conferenceJoined: false,
    conferenceLeft: false,
    isConnectedAudioGhost: false,
    isHybridSession: false, //CUSTOM
    dashboardLogin: true,
    roomPassProtectModal: false,
    isUserLogin: false,
    userLoginData: {
        isAdmin: false,
        isOpenRoom: false,
        isAlreadyPaid: false,
        isLogged: false,
        isOpenRoom: false,
        isPrivate: false, //MAKE this private by default, we can stop conference, However if isPrivate is false we will join the conference
        isRoomClaimed: false,
        data: '',
        room: '',
        user: ''
    },
    avatarPopShow: false,
    isClaimClicked: false,
    isAudioGhostLobby: false,
    chatFiles: '',
    chatFilesVisible: false,
    lobbyStatus: false,
    appBaseUrls: {},
    stemRecording: false,
    stemRecordingUrl: "",
    delayPanning: PANNING_VAR.NO_PANNING,
    prevPanning: [],
    devicesUsers: "",
    isHostInitWaiting: true,
    // DUET	
    tokenDecodedData: '',
    authVerifyToken: '',
    teacherWaitTimer: 0,
    studentGrantModerator: {
        add: false,
        remove: false,
        jitsiId: ''
    },
    authRoomUsers: [],
    recordingStopped: false,
    thirdPartyUser: {},
    // hostTabData : {
    //     users : [],
    // }
    // defaultRecordingType: "JIBRI"
    prejoinDeviceCode: "",
    clickedAutoMakeHost: getBaseConfig("selectAutoHostCheckbox"),
    hostRefresh: false,
    isLogout: false
}, action) => {
    let reponseobj = {};
    switch (action.type) {
        case SET_ACTIVE_MODAL_ID:
            displayConsole('SET_ACTIVE_MODAL_ID', action);
            reponseobj = {
                ...state,
                activeModalId: action.activeModalId,
                modalProps: action.modalProps
            };
            return reponseobj;
        case SET_MENU_STATUS:
            return {
                ...state,
                menuStatus: action.data.menuStatus,
            };
        case UNSET_CONFERENCE:
            displayConsole("UNSET_CONFERENCE", action);
            return {
                ...state,
                conferenceLeft: action.data.conferenceLeft,
            };
        case SET_CONFERENCE_JOINED:
            displayConsole("SET_CONFERENCE_JOINED", action);
            return {
                ...state,
                conferenceJoined: action.data.conferenceJoined,
            };
        case SET_USERS_DATA:
            displayConsole('SET_USERS_DATA', action);
            reponseobj = {
                ...state,
                usersData: action.usersData
            };
            return reponseobj;
        case SET_USER_CONNECTION_STATUS:
            displayConsole('SET_USER_CONNECTION_STATUS', action);
            reponseobj = {
                ...state,
                isConnected: action.data.isConnected,
                isHelpModal: action.data.isHelpModal ? action.data.isHelpModal : false,
            };
            return reponseobj;
        case HANDLE_WEBJAM_HOME_CLICK:
            displayConsole('HANDLE_WEBJAM_HOME_CLICK', action);
            reponseobj = {
                ...state,
                isHomeButtonClick: action.data.isHomebuttonClick
            };
            return reponseobj;
        case SET_IPADDRESS_VIDEO:
            displayConsole('SET_IPADDRESS_VIDEO', action);
            reponseobj = {
                ...state,
                ipAddress: action.data.ipAddress
            };
            return reponseobj;
        case SET_SHOW_HIDE_STATUS_WEBJAM_MENU:
            displayConsole('SET_SHOW_HIDE_STATUS_WEBJAM_MENU', action);
            reponseobj = {
                ...state,
                isFromWebJam: action.data.isFromWebJam,
            };
            return reponseobj;
        case SET_INTERNET_STATUS:
            displayConsole('SET_INTERNET_STATUS', action);
            reponseobj = {
                ...state,
                isInternetConnected: action.data.isConnected
            };
            return reponseobj;
        case SET_SOCKET_CONNECTION_STATUS:
            displayConsole('SET_SOCKET_CONNECTION_STATUS', action);
            reponseobj = {
                ...state,
                isSocketConnected: action.data.isSocketConnected
            };
            return reponseobj;
        case SET_DATA:
            displayConsole('SET_DATA usersData ----- ', action);
            reponseobj = {
                ...state,
                uniqueId: action.data.uniqueId,
                room: action.data.room,
                connected: action.data.connected,
            };
            return reponseobj;
        case SET_NAME:
            displayConsole('SET_NAME', action);
            reponseobj = {
                ...state,
                profileName: action.data.profileName,
            };
            return reponseobj;
        case SET_JOIN_ROOM_MODAL_STATUS:
            displayConsole('SET_JOIN_ROOM_MODAL_STATUS', action);
            reponseobj = {
                ...state,
                joinRoomModalStatus: action.data.joinRoomModalStatus,
            };
            return reponseobj;
        case SET_VIDEO_SCREEN_STATUS:
            displayConsole('SET_VIDEO_SCREEN_STATUS', action);
            reponseobj = {
                ...state,
                videoScreenStatus: action.data.videoScreenStatus,
            };
            return reponseobj;
        case SET_PROTOCOL:
            displayConsole('SET_PROTOCAL', action);
            reponseobj = {
                ...state,
                protocolId: action.data.protocolId,
            };
            return reponseobj;
        case SET_HOST_DATA:
            displayConsole('SET_HOST_DATA', action);
            reponseobj = {
                ...state,
                hostData: action.hostData,
            };
            return reponseobj;
        case SET_END_ROOM_DATA:
            displayConsole('SET_END_ROOM_DATA', action);
            reponseobj = {
                ...state,
                endRoomData: action.data,
            };
            return reponseobj;
        case SHOW_OR_HIDE_ERROR_MODAL:
            displayConsole('SHOW_OR_HIDE_ERROR_MODAL', action);
            reponseobj = {
                ...state,
                showModalError: action.data.showModalError,
            };
            return reponseobj;
        case SHOW_HIDE_MODERATOR_DISCONNECT:
            displayConsole('SHOW_HIDE_MODERATOR_DISCONNECT', action);
            reponseobj = {
                ...state,
                showModeratorModal: action.data.showModeratorModal,
            };
            return reponseobj;
        case SHOW_HIDE_MULTIMODERATOR_DISCONNECT:
            displayConsole('SHOW_HIDE_MULTIMODERATOR_DISCONNECT', action);
            reponseobj = {
                ...state,
                showMultiModeratorModal: action.data.showMultiModeratorModal,
            };
            return reponseobj;
        case SHOW_TOAST_POPUP:
            displayConsole('SHOW_TOAST_POPUP', action);
            reponseobj = {
                ...state,
                toastModal: action.data.toastModal,
                modalText: action.data.modalText,
            };
            if (action.data.hasOwnProperty("toastSubmitFunction")) {
                reponseobj.toastSubmitFunction = action.data.toastSubmitFunction;
            } else {
                reponseobj.toastSubmitFunction = "";
            }
            if (action.data.hasOwnProperty("toastCancelFunction")) {
                reponseobj.toastCancelFunction = action.data.toastCancelFunction;
            } else {
                reponseobj.toastCancelFunction = "";
            }
            if (action.data.hasOwnProperty("toastAutoSubmit")) {
                reponseobj.toastAutoSubmit = action.data.toastAutoSubmit;
            } else {
                reponseobj.toastAutoSubmit = "";
            }
            if (action.data.hasOwnProperty("toastLeaveFunction")) {
                reponseobj.toastLeaveFunction = action.data.toastLeaveFunction;
            } else {
                reponseobj.toastLeaveFunction = "";
            }
            return reponseobj;
        case CLOSE_VIDEO:
            displayConsole('CLOSE_VIDEO', action);
            reponseobj = {
                ...state,
                closeVideo: action.data.closeVideo,
            };
            return reponseobj;
        case SET_FCM_TOKEN:
            displayConsole('SET_FCM_TOKEN', action);
            reponseobj = {
                ...state,
                fcmToken: action.data.fcmToken,
            };
            return reponseobj;
        case SET_DEVICE_LIST_DATA:
            // console.log('SET_DEVICE_LIST_DATA', action);
            reponseobj = {
                ...state,
                deviceList: action.data.deviceList,
            };
            return reponseobj;
        // CHECK VALID IP LIST
        case API_GET_IPLIST:
            displayConsole('API_GET_IPLIST', action.data);
            return {
                ...state,
                apiGetIpList: action.data,
            };
        case SET_PUBLIC_IP:
            displayConsole('SET_PUBLIC_IP', action.data);
            return {
                ...state,
                publicIp: action.data.publicIp
            };
        case SET_METRONOME_STATUS:
            reponseobj = {
                ...state,
                showBox: action.data.showBox,
                metronomeStatus: action.data.metronomeStatus,
                metronomeTimerStatus: action.data.metronomeTimerStatus,
            };
            return reponseobj;
        case SET_RECORDING:
            let saved = {
                ...state
            }
            if (action.data.hasOwnProperty("recIpAddress")) {
                saved.recIpAddress = action.data.recIpAddress;
            }
            if (action.data.hasOwnProperty("recTimeStamp")) {
                saved.recTimeStamp = action.data.recTimeStamp;
            }
            if (action.data.hasOwnProperty("recordingStarted")) {
                saved.recordingStarted = action.data.recordingStarted;
            }
            if (action.data.hasOwnProperty("streamingStarted")) {
                saved.streamingStarted = action.data.streamingStarted;
            }

            return saved;

        case STOP_RECORDING:
            displayConsole('STOP_RECORDING in REDUCER ------------------------->>', action);
            return {
                ...state,
                recordingStopped: action.data.recordingStopped,
                //downloadRecording: action.data.downloadRecording
            };
        case SET_BUFFER_STATUS:
            return {
                ...state,
                isBuffer: action.data.isBuffer
            };
        case SET_LATENCY_STATUS:
            return {
                ...state,
                latencyData: action.data
            };
        case GHOST_LIST:
            return {
                ...state,
                ghostList: action.data
            };
        case SET_ROOM_OR_IP:
            return {
                ...state,
                roomorIpAddress: action.data
            };
        case HOST_TAB_DATA:
            return {
                ...state,
                hostTabData: action.data
            };
        case CLICK_MAKE_HOST:
            return {
                ...state,
                clickMakeHost: action.data
            };
        case HOST_TAB_RELOAD:
            //displayConsole("HOST tab reload", action.data)
            return {
                ...state,
                hostReload: action.data
            };
        case SHOW_BUFFER_LOADER:
            displayConsole('SHOW_BUFFER_LOADER', action.data);
            return {
                ...state,
                showBufferLoader: action.data,
            };
        case AUDIO_GHOST:
            displayConsole('AUDIO_GHOST', action.data);
            return {
                ...state,
                audioGhost: action.data,
            };
        case GHOST_VOICESYNC:
            displayConsole('GHOST_VOICESYNC', action.data);
            return {
                ...state,
                isVoiceSync: action.data,
            };
        case CONNECT_AUDIO_GHOST:
            displayConsole('CONNECT_AUDIO_GHOST', action.data);
            return {
                ...state,
                audioGhostId: action.data.audioGhostId,
                isConnectedAudioGhost: action.data.isConnectedAudioGhost,
            };
        //CUSTOM:
        case SET_HYBRID_SESSION:
            return {
                ...state,
                isHybridSession: action.isHybridSession
            };
        case SHOW_API_LOADER:
            //displayConsole('SHOW_API_LOADER', action.data);
            let returnData = {
                ...state,
                showLoader: true,
                textMessage: action.data,
            }
            if (action.data.hasOwnProperty("loaderAdditionalDetail")) {
                returnData.loaderAdditionalDetail = action.data.loaderAdditionalDetail;
            }
            return returnData;

        case HIDE_API_LOADER:
            //displayConsole('HIDE_API_LOADER', action);
            return {
                ...state,
                showLoader: false,
            };
        case SET_LOGIN_MODAL:
            //displayConsole('HIDE_API_LOADER', action);
            return {
                ...state,
                dashboardLogin: action.dashboardLogin,
            };
        case SET_USER_IS_LOGIN:
            //displayConsole('HIDE_API_LOADER', action);
            return {
                ...state,
                isUserLogin: action.isUserLogin,
            };
        case SET_USER_LOGIN_DATA:
            //displayConsole('HIDE_API_LOADER', action);
            return {
                ...state,
                userLoginData: action.userLoginData,
            };
        case SET_ROOM_PASS_PROTECT:
            return {
                ...state,
                roomPassProtectModal: action.roomPassProtectModal,
            };
        case SET_GHOST_RECORDING:
            return {
                ...state,
                ghostUserId: action.ghostUserId
            };
        case AUTO_MAKE_HOST:
            displayConsole('AUTO_MAKE_HOST', action);
            reponseobj = {
                ...state,
                isAutoMakeHost: action.data.isAutoMakeHost,
                isAutoMakeModal: action.data.isAutoMakeModal ? action.data.isAutoMakeModal : false,
                isAutoMakeHostUniqueId: action.data.isAutoMakeHostUniqueId ? action.data.isAutoMakeHostUniqueId : "",
            };
            return reponseobj;
        case CLICK_AUTO_MAKE_HOST:
            displayConsole('CLICK_AUTO_MAKE_HOST', action);
            reponseobj = {
                ...state,
                clickedAutoMakeHost: action.data.clickedAutoMakeHost,
            };
            return reponseobj;
        case SET_WAITING_SCREEN:
            console.log('------ SET_WAITING_SCREEN ------', action);
            reponseobj = {
                ...state,
                isWaiting: action.isWaiting,
            };
            return reponseobj;
        case SET_WAITING_SCREEN_STATUS:
            return {
                ...state,
                isWaitingScreen: action.isWaitingScreen
            }
        case SET_CLOSE_AVATAR_POP:
            reponseobj = {
                ...state,
                avatarPopShow: action.avatarPopShow,
            };
            return reponseobj;

        case SET_HOST_REFRESH:
            return {
                ...state,
                hostRefresh: action.hostRefresh
            }
        case SET_HOST_REFRESH_TIMER:
            return {
                ...state,
                hostRefreshTimer: action.hostRefreshTimer
            }
        case SET_IS_CLAIM_CLICKED:
            return {
                ...state,
                isClaimClicked: action.isClaimClicked
            }
        case SET_AUDIO_GHOST_CONNECT:
            return {
                ...state,
                isAudioGhostLobby: action.isAudioGhostLobby
            }
        case SET_CHAT_RECORDING_FILES:
            return {
                ...state,
                chatFiles: action.chatFiles
            }
        case SET_CHAT_RECORDING_FILES_VISIBILITY:
            return {
                ...state,
                chatFilesVisible: action.chatFilesVisible
            }

        case SET_LOBBY_STATUS:
            return {
                ...state,
                lobbyStatus: action.lobbyStatus
            }
        case SET_APP_URLS:
            return {
                ...state,
                appBaseUrls: action.appBaseUrls
            }

        case SET_STEM_RECORDING:
            return {
                ...state,
                stemRecording: action.stemRecording
            }
        case SET_STEM_RECORDING_URL:
            return {
                ...state,
                stemRecordingUrl: action.stemRecordingUrl
            }
        case SET_DELAY_PANNING:
            return {
                ...state,
                delayPanning: action.delayPanning,
                additionalDelay: action.additionalDelay
            }
        case SET_PREV_PANNING:
            return {
                ...state,
                prevPanning: action.prevPanning
            }
        case SET_DEVICES_USERS:
            return {
                ...state,
                devicesUsers: action.devicesUsers
            }
        case SET_HOST_WAIT_INIT:
            return {
                ...state,
                isHostInitWaiting: action.isHostInitWaiting
            }
        case SET_DECODED_DATA:
            return {
                ...state,
                tokenDecodedData: action.tokenDecodedData
            }
        case SET_AUTH_VERIFY_TOKEN:
            return {
                ...state,
                authVerifyToken: action.authVerifyToken
            }
        case SET_TEACHER_WILL_WAIT:
            return {
                ...state,
                teacherWaitTimer: action.teacherWaitTimer
            }
        case SET_STUDENT_MODERATOR:
            return {
                ...state,
                studentGrantModerator: action.studentGrantModerator
            }
        case SET_ROOM_USERS:
            return {
                ...state,
                authRoomUsers: action.authRoomUsers
            }
        case SET_STUDENT_SECOND_MODERATOR:
            return {
                ...state,
                secondModerator: action.secondModerator
            }
        // case SET_RECORDING_TYPE:
        //     return {
        //         ...state,
        //         defaultRecordingType: action.defaultRecordingType
        //     }
        case SET_THIRD_PARTY_HOST_TAB_DATA:
            return {
                ...state,
                thirdPartyUser: action.thirdPartyUser
            };
        case HOST_TAB_DATA_MAIN:
            return {
                ...state,
                hostTabDataMain: action.data
            };
        case SET_PREJOIN_INFO_CODE:
            return {
                ...state,
                prejoinDeviceCode: action.prejoinDeviceCode
            };
        case SET_IS_LOGOUT:
            return {
                ...state,
                isLogout: action.isLogout
            }


    }

    return state;
});

ReducerRegistry.register('trmc/customLoader/modal', (state = {
    showLoader: false,
    textMessage: '',
    loaderAdditionalDetail: ''
}, action) => {
    switch (action.type) {
        case SHOW_API_LOADER:
            //displayConsole('SHOW_API_LOADER', action.data);
            let returnData = {
                ...state,
                showLoader: true,
                textMessage: action.data,
                loaderAdditionalDetail: ""
            }

            if (action.data.hasOwnProperty("loaderAdditionalDetail")) {
                // if (action.data?.type) {
                returnData.loaderAdditionalDetail = action.data.loaderAdditionalDetail;
                // }
            }


            return returnData;


        case HIDE_API_LOADER:
            //displayConsole('HIDE_API_LOADER', action);
            return {
                ...state,
                showLoader: false,
                // loaderAdditionalDetail : ''
            };
    }
    return state;
});
